import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import ContactSupportButton from '~/components/ContactSupportButton';
import { isAccountingQbo } from '~/types/api.model';
export const accountingTextsPath = 'integrations.accounting';
export const getSubHeaderByIntegration = (accountingTexts, integration)=>{
    if (integration && integration.isErrored()) return accountingTexts.failedToConnectContactSupport({
        contactSupport: /*#__PURE__*/ _jsx(ContactSupportButton, {
            skin: "error"
        })
    });
    return '';
};
export const reportQboDisconnect = (accounting, param, ids)=>{
    let { reportToAppcues, reportToGtm, reportToHubspot } = param;
    if (!isAccountingQbo(accounting)) return;
    reportToAppcues('button-click', 'qbo-vendor-disconnect-connection');
    reportToGtm('button-click', 'qbo-vendor-disconnect-connection', _object_spread({}, ids));
    reportToHubspot('vendor_disconnects_qbo_connection');
};
export const reportQboChooseAccounts = (accounting, param)=>{
    let { reportToHeap, reportToHubspot } = param;
    if (!isAccountingQbo(accounting)) return;
    reportToHeap('integrations', 'click', 'qbo-choose-accounts');
    reportToHubspot('vendor_started_contact_sync');
};
export const reportQboMapContacts = (accounting, param, ids)=>{
    let { reportToAppcues, reportToGtm, reportToHeap, reportToHubspot } = param;
    if (!isAccountingQbo(accounting)) return;
    reportToAppcues('button-click', 'qbo-vendor-started-contacts-map');
    reportToGtm('button-click', 'qbo-vendor-started-contacts-map', _object_spread({}, ids));
    reportToHeap('integrations', 'click', 'qbo-map-contacts');
    reportToHubspot('vendor_started_contact_sync');
};
export const reportQboMapServices = (accounting, param, ids)=>{
    let { reportToAppcues, reportToGtm, reportToHeap, reportToHubspot } = param;
    if (!isAccountingQbo(accounting)) return;
    reportToAppcues('button-click', 'qbo-vendor-started-services-map');
    reportToGtm('button-click', 'qbo-vendor-started-services-map', _object_spread({}, ids));
    reportToHeap('integrations', 'click', 'qbo-map-services');
    reportToHubspot('vendor_started_services_sync');
};
